import { Divider, Modal, Spin } from "antd";
import React from "react";
import AppLogo from "../../assets/images/AppLogo.png";
import { FormattedMessage } from "react-intl";

const ContractAmountDetailsModal = ({
  visible,
  title,
  contractId,
  gigmiCharges,
  flatAmount,
  breakdown,
  useServerFee = false,
  cancelAction,
  confirmAction,
  cancelText,
  confirmText,
}) => {
  // Stripe charge flow (`useServerFee`): render the server `breakdown` verbatim so the
  // total equals the actual charge — and while it's still resolving (`breakdown` null),
  // show a spinner rather than the legacy flat fee, which would be the WRONG number for
  // a percent fee. Legacy callers (estimate/offer, non-Stripe) pass no `useServerFee`
  // and keep the flat-fee display unchanged.
  const serverFeePending = useServerFee && !breakdown;
  const fee = breakdown ? breakdown.gigmiFee : gigmiCharges;
  const amount = breakdown ? breakdown.flatAmount : flatAmount;
  const total = breakdown
    ? breakdown.total
    : parseFloat(gigmiCharges ?? 0) + parseFloat(flatAmount);
  const totalDisplay = Number(total).toFixed(2);
  return (
    <Modal open={visible} footer={null} onCancel={cancelAction}>
      <div className="d-flex flex-column" style={{ fontFamily: "Poppins" }}>
        <div className="w-100 d-flex justify-content-center mt-2">
          <img src={AppLogo} />
        </div>
        <span
          className="d-flex justify-content-center mt-3 mb-3 fs-5 fw-bold "
          style={{ color: "#f77e0b" }}
        >
          {title}
        </span>
        <div>
          {contractId && (
            <div className="d-flex justify-content-between mt-2">
              <span>
                <FormattedMessage id="CONTRACT_NO" />
              </span>
              <span>{contractId}</span>
            </div>
          )}
          {serverFeePending ? (
            <div className="d-flex justify-content-center mt-3 mb-2">
              <Spin />
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between mt-2">
                <span>
                  <FormattedMessage id="CONTRACT_AMOUNT" />
                </span>
                <span>$ {amount}</span>
              </div>
              {/* A server-sourced $0.00 is a real answer, so show the row rather than
                  hiding it — an absent fee line reads as "no fee was calculated". The
                  legacy branch keeps the old hide-when-empty behaviour. */}
              {breakdown || fee ? (
                <div className="d-flex justify-content-between mt-2">
                  <span>
                    <FormattedMessage id="TRANSACTION_FEE" />
                  </span>
                  <span>$ {Number(fee ?? 0).toFixed(2)}</span>
                </div>
              ) : null}
              {breakdown?.explanation ? (
                <div
                  className="mt-1"
                  style={{ fontSize: "0.8rem", color: "#8c8c8c" }}
                >
                  {breakdown.explanation}
                </div>
              ) : null}
              <div className="d-flex justify-content-between mt-2">
                <span className="fw-bold">
                  <FormattedMessage id="TOT_AMOUNT" />
                </span>
                <span className="fw-bold">$ {totalDisplay}</span>
              </div>
            </>
          )}
          {serverFeePending ? null : (
            <div className="d-flex justify-content-center mt-5 w-100 fw-bold">
              <span>$ {totalDisplay}</span>
            </div>
          )}
        </div>
        <Divider />
        {(cancelText || confirmText) && <div />}
        <div className="d-flex justify-content-around fw-bold">
          {cancelText ? (
            <>
              <div
                onClick={cancelAction}
                style={{ cursor: "pointer", color: "#f77e0b" }}
              >
                <span>{cancelText}</span>
              </div>
            </>
          ) : null}
          {confirmText ? (
            <div
              onClick={serverFeePending ? undefined : confirmAction}
              style={{
                cursor: serverFeePending ? "not-allowed" : "pointer",
                color: serverFeePending ? "#c8c8c8" : "#f77e0b",
              }}
            >
              <span>{confirmText}</span>
            </div>
          ) : null}
        </div>
      </div>
    </Modal>
  );
};

export default ContractAmountDetailsModal;
